import React from "react";
import PropTypes from "prop-types";
//Material imports
import IconButton from "@mui/material/IconButton";
import Send from "@mui/icons-material/Send";
import withStyles from "@mui/styles/withStyles";
import CloseIcon from "@mui/icons-material/Close";
import ImageAttachFileIcon from "@limitless/icons/Image";
import CircularProgress from "@mui/material/CircularProgress";
//Limitles imports
import { withi18n } from "../hocs/i18n";
import { useCustomerMessageContext } from "../../hooks";
import { validateImageAttachment } from "../../../expert/utils/FieldValidators";
import { wrapTextForRTL } from "../footers/rate-finish-message-overlay/TestimonialScreen";
const ResponseBox = ({
  onClickHandle,
  t,
  classes,
  scrollConversationCallback,
  onTypingHandler,
  message
}) => {
  const [localState, setLocalState] = React.useState({
    response: "",
    showSend: false
  });
  const {
    enableAttachment,
    allowedAttachmentTypesByCustomer
  } = message;
  const {
    addCustomerAttachmentFile,
    previewImage,
    setPreviewImage
  } = useCustomerMessageContext();
  const [visiblity, setvisiblity] = React.useState(true);
  const checkForResponseSubmit = e => {
    if (e.key === "Enter" && e.shiftKey && localState.showSend) {
      handleResponseSubmit();
    }
  };
  const customerAllowedAttachmentTypes = allowedAttachmentTypesByCustomer ? allowedAttachmentTypesByCustomer === null || allowedAttachmentTypesByCustomer === void 0 ? void 0 : allowedAttachmentTypesByCustomer.replaceAll("|", ",") : "";
  const handleResponseChange = event => {
    let response = event.target.value;
    response = response.trim() === "" ? response.trim() : response;
    const showSend = response.trim().length > 0 || previewImage ? true : false;
    setLocalState({
      response,
      showSend,
      focusClassName: ""
    });
    if (typeof onTypingHandler === "function") {
      onTypingHandler(showSend);
    }
  };
  const handleResponseSubmit = () => {
    if (previewImage) {
      onClickHandle(null, false, false, updateResponseBox);
      setvisiblity(false);
      addCustomerAttachmentFile(message, previewImage, localState.response, result => {
        if (result) {
          setLocalState({
            showSend: false
          });
          setPreviewImage(null);
          setvisiblity(true);
        }
      });
    } else {
      onClickHandle(localState.response, false, false, updateResponseBox);
    }
  };
  const updateResponseBox = () => {
    setLocalState({
      response: "",
      showSend: false
    });
    if (typeof onTypingHandler === "function") {
      onTypingHandler(false);
    }
  };
  const handleCancelFile = () => {
    const showSend = (response === null || response === void 0 ? void 0 : response.trim().length) > 0 || previewImage ? true : false;
    setPreviewImage(null);
    setLocalState({
      response,
      showSend
    });
    onClickHandle(null, false, false, updateResponseBox);
  };
  const handleBlur = () => {
    //see above, once the textbox closes, scroll to the bottom
    scrollConversationCallback();
  };
  const handleBrowseExplorer = event => {
    event.preventDefault();
    document.getElementById("customerAttachmentFile").click();
  };
  const handleFileSelected = event => {
    event.preventDefault();
    const responseImage = event.target.files[0];
    const {
      imageAttachmentError
    } = validateImageAttachment(responseImage);
    if (imageAttachmentError !== "") {
      setPreviewImage(null);
      setLocalState({
        response,
        showSend: false
      });
      onClickHandle(null, true, false, updateResponseBox);
    } else {
      setPreviewImage(responseImage);
      setLocalState({
        response,
        showSend: true
      });
      onClickHandle(null, false, true, updateResponseBox);
    }
  };
  const {
    showSend,
    response
  } = localState;
  const {
    sendVisible,
    sendHidden
  } = classes;
  return visiblity ? /*#__PURE__*/React.createElement("div", {
    className: classes.container
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.subContainer
  }, previewImage && /*#__PURE__*/React.createElement("div", {
    className: classes.sendIconContainer
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.customerImagePreviewContainer
  }, /*#__PURE__*/React.createElement("img", {
    src: URL.createObjectURL(previewImage),
    className: classes.customerImagePreview,
    alt: "preview"
  })), /*#__PURE__*/React.createElement(IconButton, {
    className: classes.CloseButton,
    onClick: handleCancelFile
  }, /*#__PURE__*/React.createElement(CloseIcon, {
    className: classes.icon
  })))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: classes.subContainer
  }, (enableAttachment === null || enableAttachment === void 0 ? void 0 : enableAttachment.includes("customer")) && /*#__PURE__*/React.createElement("div", {
    className: classes.sendIconContainer && sendVisible
  }, /*#__PURE__*/React.createElement(IconButton, {
    "aria-label": "Attachment",
    onClick: handleBrowseExplorer,
    component: "div",
    id: "customerAttachmentButton",
    tooltip: "Attach a file",
    className: classes.attachButton,
    size: "large"
  }, /*#__PURE__*/React.createElement(ImageAttachFileIcon, {
    style: {
      marginTop: 3
    }
  }))), /*#__PURE__*/React.createElement("input", {
    id: "customerAttachmentFile",
    key: Math.random().toString(36),
    type: "file",
    accept: customerAllowedAttachmentTypes,
    onChange: handleFileSelected,
    style: {
      display: "none"
    }
  }), /*#__PURE__*/React.createElement("textarea", {
    onKeyDown: checkForResponseSubmit,
    placeholder: wrapTextForRTL(t("Type to respond...")),
    onChange: handleResponseChange,
    value: response !== null && response !== void 0 ? response : "",
    className: classes.textarea
    // onFocus={handleFocus}
    ,
    onBlur: handleBlur
    // ref={el => (responseBox = el)}
    ,
    id: "responseTextArea",
    "aria-label": t("Type to respond")
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.sendIconContainer && showSend ? sendVisible : sendHidden
  }, /*#__PURE__*/React.createElement(IconButton, {
    "aria-label": "Menu",
    onClick: handleResponseSubmit,
    component: "div",
    id: "responseSubmitButton",
    className: classes.attachButton,
    size: "large"
  }, /*#__PURE__*/React.createElement(Send, null)))))) : /*#__PURE__*/React.createElement("div", {
    className: classes.loadingSpinnerDiv
  }, /*#__PURE__*/React.createElement(CircularProgress, {
    color: "inherit",
    size: 20
  }));
};
const styles = theme => {
  var _theme$palette$contra, _theme$palette$button, _theme$palette$button2, _theme$palette$button3, _theme$palette$button4, _theme$palette$button5, _theme$palette$button6, _theme$palette$button7;
  return {
    container: {
      color: `${theme.palette.primary.contrast} !important`,
      resize: "none",
      border: "none",
      display: "flex",
      flexDirection: "column",
      maxHeight: 50,
      boxShadow: "0 -2px 0 rgba(0, 0, 0, 0.04), 0 -1px 0 rgba(0, 0, 0, 0.06)"
    },
    customerImagePreview: {
      height: "100%",
      width: "100%",
      borderRadius: 12
    },
    customerImagePreviewContainer: {
      height: 45,
      width: 70,
      marginLeft: 16,
      paddingTop: 12,
      borderRadius: 12
    },
    subContainer: {
      color: `${theme.palette.primary.contrast} !important`,
      resize: "none",
      border: "none",
      display: "flex",
      maxHeight: 55,
      flexDirection: "row"
    },
    textarea: {
      width: "100%",
      color: `${(_theme$palette$contra = theme.palette.contrast.dark) !== null && _theme$palette$contra !== void 0 ? _theme$palette$contra : theme.palette.contrast.main} !important`,
      resize: "none",
      border: "none",
      padding: 15,
      fontSize: 14,
      fontFamily: theme.typography.fontFamily,
      margin: "0",
      maxHeight: 18,
      "&:focus": {
        outline: "none",
        backgroundColor: "#fff !important",
        boxShadow: "0 0 100px 0 rgba(150, 165, 190, 0.24) !important"
      }
    },
    CloseButton: {
      marginLeft: 72,
      padding: 0,
      height: 24,
      width: 24,
      marginTop: -100,
      backgroundColor: theme.background.paper,
      borderRadius: "50%",
      boxShadow: "0px 1px 4px rgba(0,0,0,0.2)",
      zIndex: 999,
      "&:hover": {
        backgroundColor: theme.background.paper
      }
    },
    icon: {
      fontSize: 16
    },
    loadingSpinnerDiv: {
      height: 50,
      minHeight: 50,
      alignItems: "center",
      justifyContent: "center",
      display: "flex",
      color: (_theme$palette$button = (_theme$palette$button2 = theme.palette.buttons) === null || _theme$palette$button2 === void 0 ? void 0 : (_theme$palette$button3 = _theme$palette$button2.submit) === null || _theme$palette$button3 === void 0 ? void 0 : _theme$palette$button3.backgroundColor) !== null && _theme$palette$button !== void 0 ? _theme$palette$button : theme.palette.primary.main
    },
    //iOS only stylings.. i hope :)
    "@supports (-webkit-overflow-scrolling: touch)": {
      textarea: {
        fontSize: 16
      }
    },
    sendIconContainer: {
      backgroundColor: "white"
    },
    sendHidden: {
      display: "none",
      transition: "opacity 1s ease-out",
      opacity: "0"
    },
    sendVisible: {
      opacity: "1",
      display: "block"
    },
    sendButton: {
      color: theme.palette.buttons ? (_theme$palette$button4 = theme.palette.buttons) === null || _theme$palette$button4 === void 0 ? void 0 : (_theme$palette$button5 = _theme$palette$button4.send) === null || _theme$palette$button5 === void 0 ? void 0 : _theme$palette$button5.color : theme.palette.contrast.main
    },
    attachButton: {
      color: theme.palette.buttons ? (_theme$palette$button6 = theme.palette.buttons) === null || _theme$palette$button6 === void 0 ? void 0 : (_theme$palette$button7 = _theme$palette$button6.send) === null || _theme$palette$button7 === void 0 ? void 0 : _theme$palette$button7.color : theme.palette.primary.light
    }
  };
};
export default withStyles(styles, {
  withTheme: true
})(withi18n(ResponseBox, "Response"));
ResponseBox.propTypes = {
  onClickHandle: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
  classes: PropTypes.object.isRequired,
  message: PropTypes.object.isRequired,
  scrollConversationCallback: PropTypes.func.isRequired,
  logger: PropTypes.object.isRequired,
  onTypingHandler: PropTypes.func
};